import styled from 'styled-components';

export const Container = styled.div`
  border: 0px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  & button {
    position: relative;
    border: 1px solid gray;
    border-radius: 3px;
    text-transform: uppercase;
    font-weight: bold;
    height: 40px;
    width: 45%;
    background-color: #0095E8;
    :disabled {
      cursor: not-allowed;
      background-color: #e7e7e7;
      color: #666;
    }
  }
`;

export const HotKeyLabel = styled.div`
  position: absolute;
  bottom: 5px;
  right: 5px;
  font-size: 0.75em;
`;

export default Container;
